import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const mating: ImportTypeConfig = {
  type: 'mating',
}
